import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="webview-dropdown"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.setupDropdownEvents()
  }

  setupDropdownEvents() {
    const dropdown = this.element
    const button = this.buttonTarget

    if (dropdown && button) {
      // Listen to Bootstrap dropdown events using jQuery (since it's already used in the original code)
      if (typeof $ !== 'undefined') {
        $(dropdown).on('show.bs.dropdown', () => {
          button.classList.add('rotated')
        })
        
        $(dropdown).on('hide.bs.dropdown', () => {
          button.classList.remove('rotated')
        })
      } else {
        // Fallback for environments without jQuery
        dropdown.addEventListener('show.bs.dropdown', () => {
          button.classList.add('rotated')
        })
        
        dropdown.addEventListener('hide.bs.dropdown', () => {
          button.classList.remove('rotated')
        })
      }
    }
  }
}